
/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});




jQuery(".aboutpage").click(function () {
	jQuery('html,body').animate({scrollTop: eval($('#' + $(this).attr('target')).offset().top-jQuery("#about").height())},1000);
});

//Load More button
$(function () {
    $(".partner-logo-wrapper").slice(0, 12).show();
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".partner-logo-wrapper:hidden").slice(0, 4).slideDown();
        if ($(".partner-logo-wrapper:hidden").length == 0) {
            $("#load").fadeOut('slow');
        }
    });
});

$('#myModal').modal({
	backdrop: 'static'
});

$(document).ready(function() {
    $('.nav-container .nav').meanmenu({
        meanScreenWidth: "1147"
    });
});

$(window).load(function() {
    $('body, #wrapper, .footer-wrapper').css({
        opacity: 1
    });
});

jQuery(document).ready(function($) {
$('.navigation').click(function() {
$('.side-nav').toggleClass('active');
});

$('.snav').click(function() {
$('.secondary-nav ul').toggleClass('active');
});

$('.tp-btn').click(function() {
$('.tp-search-holder').addClass('active');
$("body").css("overflow", "hidden");
});
$('.tp-btn-close').click(function() {
$('.tp-search-holder').removeClass('active');
$("body").css("overflow", "auto");
});

// browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = $('.cd-top');

    //hide or show the "back to top" link
    $(window).scroll(function() {
        ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible'): $back_to_top.removeClass('cd-is-visible cd-fade-out');
        if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass('cd-fade-out');
        }
    });

    //smooth scroll to top
    $back_to_top.on('click', function(event) {
        event.preventDefault();
        $('body,html').animate({
                scrollTop: 0,
            }, scroll_top_duration
        );
    });

    //Home Banner Slider
    var $status = $('.pagingInfo');
    var $slickElement = $('.home-banner');
    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.html('<span class="active">0' + i + '</span>/' + '0' + slick.slideCount);
    });
    $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover:false,
		infinite: true,
        slide: 'div',
        arrows: false,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-arrow-left"></i> <span class="ar-shape"></span> </button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-arrow-right"></i></button>',
        fade: false,
    });
    //Home Banner Slider END
}); //(document).ready function-END

/*equalheight start*/
equalheight = function(container){
var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {
   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;
   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0;
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}

$(window).load(function() {
	//equalheight('.equalheight1');
	equalheight('.tm-content-box');
	equalheight('.serv-item a');
	equalheight('.service-box-data p');
	equalheight('.corv-detail');
	equalheight('.certif-box');
	equalheight('.cv-list li');
	equalheight('.contact-detail-list li');


});

$(window).resize(function(){
	//equalheight('.equalheight1');
	equalheight('.tm-content-box');
	equalheight('.serv-item a');
	equalheight('.service-box-data p');
	equalheight('.corv-detail');
	equalheight('.certif-box');
	equalheight('.cv-list li');
	equalheight('.contact-detail-list li');

});
/*equalheight End*/

$(window).on("load resize", function (e) {
  if (!($('.home-banner').length)) {
			$('.navbar').addClass('fixed-top');
  }

    var s = $(".home-banner").height();
		var navHeight = $( window ).height();
		// console.log(s);

  $(window).bind('scroll', function () {
    if ($('.home-banner').length) {
      if ($(window).scrollTop() > s) {
        $('.navbar').addClass('fixed-top');
      }
      else {
        $('.navbar').removeClass('fixed-top');
      }
    }
	});
});

// activate scrollspy on sections navigation
$('body').scrollspy({
  target: '.navbar-nav',
  offset: 84,
});

// Smooth Scroll, pure Javascript, no library
initSmoothScrolling();
function initSmoothScrolling() {
  var duration = 400;
  var pageUrl = location.hash ?
    stripHash(location.href) :
    location.href;
  delegatedLinkHijacking();
  //directLinkHijacking();

  function delegatedLinkHijacking() {
    document.body.addEventListener('click', onClick, false);
    function onClick(e) {
      if (!isInPageLink(e.target))
        return;
      e.stopPropagation();
      e.preventDefault();
      jump(e.target.hash, {
        duration: duration,
        callback: function() {
          setFocus(e.target.hash);
        }
      });
    }
  }

  function directLinkHijacking() {
    [].slice.call(document.querySelectorAll('a'))
      .filter(isInPageLink)
      .forEach(function(a) {
        a.addEventListener('click', onClick, false);
      });

    function onClick(e) {
      e.stopPropagation();
      e.preventDefault();

      jump(e.target.hash, {
        duration: duration,
      });
    }
  }

  function isInPageLink(n) {
    return n.tagName.toLowerCase() === 'a' &&
      n.hash.length > 0 &&
      stripHash(n.href) === pageUrl;
  }

  function stripHash(url) {
    return url.slice(0, url.lastIndexOf('#'));
  }

  // Adapted from:
  // https://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
  function setFocus(hash) {
    var element = document.getElementById(hash.substring(2));
    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  }
}

function jump(target, options) {
	var StickyMenuHeight = $('#mainNav').height();
	var lsh = 84;
	if(!$('#mainNav').hasClass('fixed-top'))
	{
		lsh = lsh + StickyMenuHeight;
	}

  var
    start = window.pageYOffset,
    opt = {
      duration: options.duration,
      offset: options.offset || 3,
      callback: options.callback,
      easing: options.easing || easeInOutQuad
    },
    distance = typeof target === 'string' ?
    (opt.offset + document.querySelector(target).getBoundingClientRect().top) - lsh :
    target,
    duration = typeof opt.duration === 'function' ?
    opt.duration(distance) :
    opt.duration,
    timeStart, timeElapsed;

  requestAnimationFrame(function(time) {
    timeStart = time;
    loop(time);
  });

  function loop(time) {
    timeElapsed = time - timeStart;

    window.scrollTo(2, opt.easing(timeElapsed, start, distance, duration));

    if (timeElapsed < duration)
      requestAnimationFrame(loop)
    else
      end();
  }

  function end() {
    window.scrollTo(2, start + distance);

    if (typeof opt.callback === 'function')
      opt.callback();
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
}




//clients Slider
$('.clients-slide').slick({
	slidesToShow: 6,
	slidesToScroll:5,
	setPosition: 1,
	speed: 1000,
	autoplay: true,
	autoplaySpeed: 3000,
	dots: false,
	slide: 'div',
	arrows: true,
	infinite: true,
	focusOnSelect: false,
	centerMode: false,
	prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-arrow-left"></i></button>',
	nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-arrow-right"></i></button>',
	responsive: [{
		breakpoint: 959,
		settings: {
			slidesToShow: 2,
			slidesToScroll:2,
			}
		},
		{
			breakpoint:568,
			settings: {
				slidesToShow: 3,
				slidesToScroll:3,
			}
		},
		{
			breakpoint: 567,
			settings: {
				centerMode: false,
				slidesToShow: 3,
				slidesToScroll:3,
			}
		},
	]
});

$(document).ready(function() {
	$("a.fancybox").fancybox({
		'width':800,
		'height':500,
		'autoSize' : false,
	});

	$("a.fancybox-popup").fancybox({
		'width':1200,
		'height':'auto',
		'autoSize' : true,
	})


	$(".team-member-box .arrow-btn span").click(function(){
	    setTimeout(function(){ $(".collapse").matchHeight(); }, 400);

	})

});
